import thunk from 'redux-thunk';
import {
  applyMiddleware, compose, createStore, combineReducers
} from 'redux';
import feData from './redux/fe-data/reducer';
import personaData from './redux/persona/reducer';
import servicesData from './redux/services/reducer';
import contactMethods from './redux/contactMethods/reducer';
import notificationRules from './redux/notificationRules/reducer';
import incidentData from './redux/incidents/reducer';

const allReducers = combineReducers({
  feData,
  personaData,
  servicesData,
  contactMethods,
  notificationRules,
  incidentData,
});

let allStoreEnhancers = compose(
  applyMiddleware(thunk)
);

// split this to avoid an error when devToolsExtension is null
if (window.devToolsExtension) {
  allStoreEnhancers = compose(allStoreEnhancers, window.devToolsExtension());
}

const store = createStore(allReducers, undefined, allStoreEnhancers);

export default store;
